import { gql } from 'apollo-angular'

export const GET_BILLING_CYCLES = gql`
  query BillingCycles($organizationId: JSON!) {
    BillingCycles(
      select: true
      where: { organization: { equals: $organizationId } }
    ) {
      docs {
        id
        frequency
        startDate
        nextInvoicingDate
        renewalDay
        hasStarted
        canPlanNextPeriod
        reference
      }
    }
  }
`
